export const PROF_TEST_UTM =
  'utm_source=site&utm_medium=banners&utm_campaign=1288_career-guidance_site_banners_banners_proforientation_{{region}}_all_lernatv';
